import OAuthCallbackScreen from '@/src/auth/callbackScreen';

export default OAuthCallbackScreen;
